import GamePostMessageHandlerBase from './game_post_message_handler_base';

export default class VoidGamePostMessageHandler extends GamePostMessageHandlerBase {
    static CLASS = 'VoidGamePostMessageHandler';

    canExecuteAction(gameOptions, actionName, params) {
        return true;
    }

    executeAction(gameOptions, actionName, params) {
    }
}